export const EVENTSTOREACTIONS = {
  EVENT_ADD: 'eventstore/addEvent',
  EVENT_APPLY: 'eventstore/modEvent',
  EVENT_REMOVE: 'eventstore/remEvent',
} as const;
